module.exports = __webpack_public_path__ + "img/folder-file.47b89e28.svg";